<script setup lang="ts">
import { capitalizeStr } from '@Helpers';

withDefaults(
  defineProps<{
    disabled?: boolean;
    error?: string | boolean;
    isDetails?: boolean;
    label?: string;
    required?: boolean;
    hint?: string;
    hasWhiteBackground?: boolean;
  }>(),
  {
    hasWhiteBackground: true,
  }
);
</script>

<template>
  <div
    v-if="label"
    class="flex min-w-0 items-center gap-1"
  >
    <label
      :class="[
        'min-w-0 break-words text-sm font-medium',
        { 'bg-white': hasWhiteBackground },
        { 'text-red-600': !!error },
        { '!text-gray-500': !!disabled && !isDetails },
      ]"
    >
      {{ capitalizeStr($t(label)) }}<span class="text-red-600">{{ required ? '*' : '' }}</span>
    </label>

    <i
      v-if="hint"
      v-tooltip.top="{
        value: $t(hint),
        pt: {
          text: 'text-sm',
        },
      }"
      class="pi pi-question-circle text-xs"
    />
  </div>
</template>
